import { useState } from "react";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import cx from "classnames";
import { debounce } from "lodash";

export const FileDropZone = props => {
  const [isOver, setIsOver] = useState(false);
  const [isValidDropTarget, setIsValidDropTarget] = useState(true);
  const { wsMgr } = useWSMgrContext();
  const ws = wsMgr.state;
  const baseClass = "oc-file-drop-zone";
  const containerClass = props?.useFlex ? `${baseClass}--flex` : null;

  const handleDragEnter = event => {
    if (!event.relatedTarget || event.currentTarget.contains(event.relatedTarget)) {
      return;
    }
    setIsOver(true);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragLeave = event => {
    if (!event.relatedTarget || event.currentTarget.contains(event.relatedTarget)) {
      return;
    }
    setIsOver(false);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragOver = event => {
    if (props?.onDragOver) props.onDragOver();
    if (props?.handleDropValidation) {
      debounce(
        () => setIsValidDropTarget(props?.handleDropValidation(props?.targetDirectory)),
        500
      );
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = event => {
    if (props.targetDirectory && isValidDropTarget) {
      ws.HandleFiles(
        event,
        props.targetDirectory,
        props?.extensionRestrictions,
        props?.allowMultiUpload
      );
    }
    setIsOver(false);
    setIsValidDropTarget(true);
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      className={cx(
        baseClass,
        containerClass,
        "oc-drop",
        isOver ? "oc-drop--add" : null,
        props.className
      )}
      id={props?.id}
    >
      {typeof props?.children === "function"
        ? props.children({ isOver, isValidDropTarget })
        : props.children}
    </div>
  );
};
